const loginDictES = {
  to: "en la",
  signInWith: "Ingresa con las credenciales de tu cuenta activada",
  forgotPassword: "¿Olvidaste tu contraseña?",
  sendEmail: "Enviar Correo electrónico",
  // toast
  pleaseFillOut: "Por favor llenar los campos de usuario y contraseña.",
  pleaseReverify: "Por favor compruebe de nuevo el ReCaptcha.",
  incorrectCredentials: "Credenciales incorrectas.",
  tooManyLoginAttempts: "Demasiados intentos de acceso fallidos. Vuelve a intentarlo en unos minutos o usa \"¿Olvidaste tu contraseña?\".",
  pleaseCheckEmail: "Por favor compruebe su correo electrónico para activar su cuenta.",
  pleaseCheckEmailTemp:
    "Revisa el enlace que recibiste en tu correo electrónico para cambiar tu contraseña. Tendrá una validez de 60 minutos.",
  userNotFound: "Usuario no encontrado.",
  thisEmailDoesnt: "Este correo electrónico no coincide con este usuario.",
  error: "Error",
  success: "Éxito",
  notRegisteredYetRegisterAs: "¿Aún no registrado? Regístrese como",
  welcomeBack: "Bienvenido",
  emailOrUsername: "Correo electrónico o nombre de usuario",
  enterRegisteredEmail: "Introduce tu correo registrado",
  enterYourPassword: "Introduce tu contraseña",
  rememberMe: "Recordarme",
  accessMyAccount: "Acceder a mi cuenta",
  notPartOfNetwork: "¿Aún no forma parte de la red?",
  createAccountNow: "Cree su cuenta ahora y comience a generar valor.",
  loginAndKeepGrowing: "Entra y sigue creciendo con Extraconomy",
  accessYourAccountDescription:
    "Accede a tu cuenta y descubre nuevas oportunidades para ampliar tu red, tus ingresos y tu impacto.",
  // Reset Password
  resetPassword: "Restablecer Contraseña",
  enterNewPassword: "Ingresa tu nueva contraseña",
  newPassword: "Nueva Contraseña",
  confirmPassword: "Confirmar Contraseña",
  confirmNewPassword: "Confirma tu nueva contraseña",
  changePassword: "Cambiar Contraseña",
  backToLogin: "Volver al inicio de sesión",
  invalidLink: "Enlace inválido o expirado. Redirigiendo al login...",
  passwordsDoNotMatch: "Las contraseñas no coinciden.",
  passwordTooShort: "La contraseña debe tener al menos 8 caracteres.",
  passwordChangedSuccessfully: "¡Contraseña cambiada con éxito! Redirigiendo al login...",
  errorChangingPassword:
    "Error al cambiar la contraseña. Intenta nuevamente o solicita un nuevo enlace.",
  resetYourPassword: "Restablece tu contraseña",
  createNewPasswordDescription: "Crea una nueva contraseña para recuperar el acceso a tu cuenta.",
  passwordAlreadyChanged: "Esta solicitud de cambio de contraseña ya ha sido utilizada.",
  enterTheEmailAddressAssociatedYourAccount: "Ingresa el correo electrónico asociado a tu cuenta",
  weWillSendYouALinkToSecurelyCreateANewPassword:
    "Te enviaremos un enlace para crear una nueva contraseña de forma segura",
  active: "Activo",
  memberCount: "Número de miembros",
  subnets: "Subredes",
  subnet: "Subred",
  loginSEODescription:
    "Inicia sesión en Extraconomy para acceder a tu cuenta, ampliar tu red de contactos y aprovechar oportunidades de negocio exclusivas.",
  // Entrada vinda da Federnet (FedernetHandoff.js)
  federnetHandoffLoading: "Te estamos llevando a Extraconomy…",
  federnetHandoffErrorTitle: "No se pudo acceder",
  federnetHandoffErrorText:
    "El enlace desde Federnet ha caducado o ya se usó. Accede con tu usuario y tu contraseña.",
  federnetHandoffGoToLogin: "Ir al acceso",
};

export default loginDictES;
